<template>
  <div>
    <vue-toastr ref="mytoast"></vue-toastr>
    <table class="table table-hover">
      <thead>
      <tr>
        <th></th>
        <th>Onlineseminar</th>
      </tr>
      </thead>
      <draggable v-model="courses" group="media" @start="drag=true" @end="updateMediaList" tag="tbody">
        <tr v-for="item in courses" :key="courses.id" style="cursor:grab;">
          <td style="width: 25px;"><i class="fa fa-bars" aria-hidden="true"></i></td>
          <td>{{ item.course_name }}</td>
        </tr>
      </draggable>
    </table>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import VueToastr from "vue-toastr";

export default {
  name: 'FmuHighlights',
  components: {draggable, VueToastr},
  props: ['courses'],
  methods: {
    updateMediaList() {
      axios.post('/api/fmu/courses/reorder', {
        courses: this.courses
      }).then(() => {
        this.$refs.mytoast.s("Neue Sortierung gespeichert", "Erfolgreich");
      }).catch(() => {
        this.$refs.mytoast.e("Versuche es noch einmal", "Fehler");
      })
    }
  }
}
</script>

<style scoped>
</style>
